// Frontend JavaScript for WP-SDGA

(function ($) {
    "use strict";

    $(document).ready(function () {
        // console.log('WP-SDGA Frontend JS Loaded');
        // Add frontend specific JS interactions here
        jQuery(document).on(
            "click",
            ".with-copy-act .elementor-button .elementor-button-icon",
            function (e) {
                e.preventDefault();
                // find the closest button and get its text
                var btn = jQuery(this).closest(".elementor-button");
                var phoneText = btn
                    .find(".elementor-button-text")
                    .text()
                    .trim();

                // helper to show & auto-remove the "copied" label
                function showCopied() {
                    var status = jQuery(
                        // '<span class="copy-status" style="margin-left:6px; font-size:0.9em; color:#4caf50;">copied</span>'
                        '<span class="copy-status copy-tooltip">' +
                            wp_sdga_copy_text.copied +
                            "</span>"
                    );
                    btn.find(".elementor-button-icon").append(status);
                    setTimeout(function () {
                        status.fadeOut(300, function () {
                            jQuery(this).remove();
                        });
                    }, 4000); // 4 seconds
                }

                // try Clipboard API first
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard
                        .writeText(phoneText)
                        .then(showCopied)
                        .catch(function () {
                            // fallback if it fails
                            fallbackCopy(phoneText);
                        });
                } else {
                    // fallback for older browsers
                    fallbackCopy(phoneText);
                }

                // fallback using a temporary textarea & execCommand
                function fallbackCopy(text) {
                    var temp = jQuery("<textarea>");
                    jQuery("body").append(temp);
                    temp.val(text).select();
                    try {
                        document.execCommand("copy");
                        showCopied();
                    } catch (err) {
                        console.error("Copy fallback failed:", err);
                    }
                    temp.remove();
                }
            }
        );
    });
})(jQuery);
